<template>
   <div id="activity">
       <template v-if="isActivity == 1">
           <div class="activity-wrap" v-if="initData">
               <!-- 固定背景 -->
               <div class="activity-background" :style="'backgroundImage: url('+ initData.m_configure.activity_back_img +');'">
                   <!-- 蒙版 -->
                   <div class="page-mask" :style="'background-color: rgba(0, 0, 0, '+ initData.m_configure.transparent +');'"></div>
               </div>

               <div class="activity-main">
                   <!-- banner计时器 -->
                   <div class="module-banner">
                       <img :src="initData.m_configure.theme_img" class="activity-banner" alt=""/>
                       <div id="countdown" class="activity-countdown" :style="'backgroundImage: url('+ initData.m_configure.count_down +');'">
                           <span class="countdown-text">距今天活动结束：</span>
                           <span class="countdown-num" :style="'backgroundImage: url('+ this.initData.m_configure.smart_count_down +');'">
                               {{ this.countData.time }}
                           </span>
                           <span class="countdown-text">时</span>
                           <span class="countdown-num" :style="'backgroundImage: url('+ this.initData.m_configure.smart_count_down +');'">
                               {{ this.countData.branch }}
                           </span>
                           <span class="countdown-text">分</span>
                           <span class="countdown-num" :style="'backgroundImage: url('+ this.initData.m_configure.smart_count_down +');'">
                               {{ this.countData.second }}
                           </span>
                           <span class="countdown-text">秒</span>
                           <span class="countdown-num" :style="'backgroundImage: url('+ this.initData.m_configure.smart_count_down +');'">
                               {{ this.countData.millisecond }}
                           </span>
                       </div>
                   </div>

                   <!-- 活动内容 -->
                   <div class="module-box">
                       <template v-for="item in initData.activity_column">
                           <!-- 优惠卷 -->
                           <div class="module-hd moduleHd_01" v-if="item.amc_type == 1">
                               <div class="module-title">
                                   <img :src="item.amc_detail.column_title_img" alt="">
                               </div>
                               <div class="mhd-content">
                                   <img :src="item.amc_detail.m_column_back_img" class="item-image" alt=""/>
                                   <div class="mhd-page">
                                       <div class="coupon-list clearFix" v-if="item.amc_detail.coupon_get_way=='1'"><!--一键领取优惠券 -->
                                           <a href="javascript:;" :class="[{'disabled':allowClick},'coupon_an','animation-img']"
                                           @click="getCouponFn"
                                           >
                                               <img :src="item.coupon_lists.free_lists[0].img" alt=""/>
                                           </a>
                                       </div>
                                       <div class="coupon-list clearFix" v-else><!--单张领取优惠券 -->
                                           <a v-for="(coupon,index) in item.coupon_lists.free_lists" :key="index"
                                              :href="$commonVariable.yihu_href_url + coupon.url" class="coupon_an animation-img">
                                               <img :src="coupon.img" alt=""/>
                                           </a>
                                       </div>
                                       <div v-for="(robvip,index) in item.coupon_lists.fee_lists" :key="index" class="coupon-buy">
                                           <img :src="robvip.img" alt=""/>
                                           <a :href="$commonVariable.yihu_href_url + robvip.url" :style="'backgroundImage: url('+ robvip.hover_img +');'" class="coupon_robvip_an"></a>
                                       </div>
                                       <a href="javascript:void(0);" @click="recomMend()" class="coupon-href">
                                           <img :src="item.amc_detail.m_column_btn_img" alt=""/>
                                       </a>
                                   </div>
                               </div>
                           </div>

                           <!-- VIP购买优惠 -->
                           <div class="module-hd moduleHd_02" v-else-if="item.amc_type == 2">
                               <div class="module-title">
                                   <img :src="item.amc_detail.column_title_img" alt="">
                               </div>
                               <div class="mhd-content">
                                   <img :src="item.amc_detail.m_column_back_img" class="item-image" alt=""/>
                                   <div class="mhd-page">
                                       <div class="mhdVip-item clearfix">
                                           <div v-for="(vip,index) in item.amc_detail.vip_arr" :key="index" class="mhdVip-show" @click="showVip()">
                                               <img :src="vip[0]"  alt=""/>
                                           </div>
                                       </div>
                                   </div>
                               </div>
                           </div>

                           <!-- 专场优惠 -->
                           <div class="module-hd moduleHd_03" v-else-if="item.amc_type == 3 && item.amc_detail">
                               <div class="module-title">
                                   <img :src="item.amc_detail.column_title_img" alt="">
                               </div>
                               <div class="mhd-content">
                                   <img :src="item.amc_detail.m_column_back_img" class="item-image" alt=""/>
                                   <div class="mhd-page">
                                       <div class="mhdEnlarge-item" v-if="item.amc_detail.type == 1">
                                           <a :href="item.amc_detail.first_type_arr[0][1]" class="enlarge-img animation-img">
                                               <img :src="item.amc_detail.first_type_arr[0][0]" alt=""/>
                                           </a>
                                       </div>
                                       <div class="mhdEnlarge-item" v-else-if="item.amc_detail.type == 2 && item.amc_detail.column_type == 1">
                                           <a v-for="(enlarge,index) in item.amc_detail.second_type_arr.first_lists" :key="index" :href="enlarge[1]" class="enlarge-img animation-img">
                                               <img :src="enlarge[0]" alt=""/>
                                           </a>
                                       </div>
                                       <div class="mhdEnlarge-list clearfix" v-else-if="item.amc_detail.type == 2 && item.amc_detail.column_type == 2">
                                           <a v-for="(enlarge,index) in item.amc_detail.new_lists" :key="index" :href="enlarge[1]" class="enlarge-img animation-img">
                                               <img :src="enlarge[0]" alt=""/>
                                           </a>
                                       </div>
                                   </div>
                               </div>
                           </div>

                           <!-- 热门课程 -->
                           <div class="module-hd moduleHd_04" v-else-if="item.amc_type == 4 && item.amc_detail">
                               <div class="module-title">
                                   <img :src="item.amc_detail.column_title_img" alt="">
                               </div>
                               <div class="mhd-content">
                                   <img :src="item.amc_detail.m_column_back_img" class="item-image" alt=""/>
                                   <div class="mhd-page">
                                       <!-- type字段 
                                            1：1个分类，无tab切换
                                            2或其它: 2-3个分类，有tab切换
                                         -->
                                       <div :class="{'mhdHot-item':item.amc_detail.type != 1}">
                                           <ul class="mhdHot-courseNav" v-if="item.amc_detail.type != 1">
                                               <li v-for="(course,index) in item.amc_detail.album_arr" :key="index" v-if="course.album_lists && course.album_lists.length > 0" :class="{ 'on': item.hotActive == index }" @click="hotAcitev(item, index)">
                                                   <img :src="course.second_column_img" alt=""/>
                                                   <img :src="course.hover_second_column_img" class="hoverIocn" alt=""/>
                                               </li>
                                           </ul>
                                           <div class="mhdHot-courseList">
                                               <ul v-for="(course,index) in item.amc_detail.album_arr" :key="index" class="mhdHot-course clearfix" v-if="item.hotActive == index && course.album_lists && course.album_lists.length > 0">
                                                   <li v-for="(album,num) in course.album_lists" :key="num" @mouseenter="courseImageSrc($event,1,course.hover_color)" @mouseleave="courseImageSrc($event,1,'')">
                                                       <a :href="$commonVariable.yihu_href_url + '/a_'+ album.album_id +'.html'" class="course-tp" target="_blank">
                                                           <img :src="album.album_smpicpath" alt="">
                                                       </a>
                                                       <div class="course-text">
                                                           <a :href="$commonVariable.yihu_href_url + '/a_'+ album.album_id +'.html'" class="bt_text" target="_blank">
                                                               {{ album.album_name }}
                                                           </a>
                                                           <div class="course-ex-wrap" v-if="course.show_card=='1'">
                                                            <div class="course-ex df ai-c" v-for="(exitem,index) in album.study_card_list">
                                                                    <span class="send-mark">赠</span>
                                                                    <!-- 学习卡:课程卡点击跳转，vip卡无点击-->
                                                                    <p v-if="exitem.study_type==1">
                                                                        <a :href="$commonVariable.yihu_href_url + '/ex/'+ exitem.study_id"  target="_blank">
                                                                        {{exitem.detail}}
                                                                        </a>
                                                                    </p>
                                                                    <p v-else>{{exitem.detail}}</p>
                                                            </div>
                                                            <!-- 当前tab，部分教程无学习卡，占位输出 -->
                                                            <div class="course-ex df ai-c vh" v-if="!album.study_card_list || !album.study_card_list.length">
                                                                <span class="send-mark">赠</span>
                                                                <p></p>
                                                            </div>
                                                           </div>
                                                           <div class="course-w1">
                                                               <div class="fl_text">
                                                                   <template v-if="course.show_orig_price == 1">
                                                                       <p class="original">价格：<span>￥{{ album.album_original_price }}</span></p>
                                                                       <p>
                                                                            特惠价：
                                                                            <span class="course_price" :style="'color: '+ course.hover_color">
                                                                                ￥{{  album.album_sale_price || album.album_price }}
                                                                            </span>
                                                                        </p>
                                                                   </template>
                                                                   <p v-else>价格：<span class="course_price" :style="'color: '+ course.hover_color">￥{{ album.album_price }}</span></p>
                                                               </div>
                                                               <a :href="$commonVariable.yihu_href_url + '/a_'+ album.album_id +'.html'" class="details" target="_blank"
                                                                  :style="'border: 2px solid'+ course.hover_color +';color: '+ course.hover_color"
                                                                  @mouseenter="courseImageSrc($event,2,course.hover_color,'')"
                                                                  @mouseleave="courseImageSrc($event,2,'',course.hover_color)">
                                                                   {{ course.btn_name }}
                                                               </a>
                                                           </div>
                                                       </div>
                                                       <!-- 课程标签图 -->
                                                       <a :href="$commonVariable.yihu_href_url + '/a_'+ album.album_id +'.html'" target="_blank">
                                                           <img class="course-tag-mark" :src="course.tag_column_back_img" v-if="course.tag_column_back_img"/>
                                                       </a>
                                                   </li>
                                               </ul>
                                           </div>
                                       </div>
                                   </div>
                               </div>
                           </div>

                           <!-- 活动须知 -->
                           <div class="module-hd moduleHd_05" v-else-if="item.amc_type == 5 && item.amc_detail">
                               <div class="module-title">
                                   <img :src="item.amc_detail.column_title_img" alt="">
                               </div>
                               <img :src="item.amc_detail.m_img" class="mhdNotice-item" alt=""/>
                           </div>

                           <!-- 消费抽奖 -->
                           <component :is="currentLotteryTpl" v-else-if="item.amc_type == 6"></component>

                           <!-- 人气爆品 买一赠一 -->
                           <div class="module-hd moduleHd_07" v-else-if="item.amc_type == 7">
                               <div class="module-title">
                                   <img src="@/assets/images/activity/mz/mz_title.png" alt="">
                                   <!-- <img :src="item.amc_detail.column_title_img" alt=""> -->
                               </div>
                               <div class="mhd-content">
                                <!-- <img src="@/assets/images/activity/mz/mz_bg.png" alt="" class="item-image"> -->
                                <img :src="item.amc_detail.column_back_img" alt="" class="item-image">
                                <div class="mhd-page">
                                    <div class="mhd-columm-box df fw js-sb">
                                        <!-- <div class="mhd-columm-item">
                                            <a href="https://m.yiihuu.com/video/zuhe.php?id=227" class="animation-img" target="_blank">
                                                <img src="@/assets/images/activity/mz/mz_01.png" alt="">
                                            </a>
                                        </div> -->
                                        
                                        <div class="mhd-columm-item"
                                         v-for="(item,index) in item.amc_detail.mz_arr"
                                         :key="index"
                                        >
                                            <a :href="item.mz_link" class="animation-img" target="_blank">
                                                <img :src="item.mz_img" alt="">
                                            </a>
                                        </div>
                                    </div>
                                </div>
                               </div>
                           </div>

                           <!-- flag留言墙 -->
                            <Barrage
                            :activityId="activityId"
                            :barrageData="item"
                            v-else-if="item.amc_type == 8"
                            ></Barrage>
                       </template>
                   </div>
               </div>

               <!-- 底部banner图 -->
               <a href="javascript:void(0);"  class="guide-bottom" @click="showVip()" :style="'backgroundImage: url('+ initData.m_configure.footer_img +');'"></a>
           </div>
       </template>
       <div class="activity-wrap" v-else>
           <h2 class="hd_notice">{{ noticeText }}</h2>
       </div>
   </div>
</template>
<script>
    import md5 from 'js-md5'

    let actPointTimer
    
    import { getToken } from '@/utils/auth'
    import { header as getHeader, user as getUser } from '@/api/common'
    import { activity as getActivity, getCoupons, acquirePoints, prizeList, selfCheat, cheatRecord, check, getPrize, cheatPrize, cheatTop, getLotteryLog, saveLotteryOther, ajaxWxLogin } from '@/api/activity/';

    import { mapGetters, mapActions } from "vuex";

    // 组件 
    const BlindBoxTpl = () => import('./components/BlindBoxTpl.vue')
    const TurntableTpl = () => import('./components/TurntableTpl.vue')
    const Barrage = () => import('./components/Barrage.vue')

    export default {
        name: "activity",
        components: {
            BlindBoxTpl,
            TurntableTpl,
            Barrage,
        },
        data() {
            return {
                initData: "",
                countTime: "",
                countData: {
                    time: 0,
                    branch: 0,
                    second: 0,
                    millisecond: 0,
                },
                hotActive: 0,//已废弃(每个热门课程模块已插入模块当前激活tab索引独立标识)
                pageScroll: true,
                isActivity: 0,
                preview: 0,
                noticeText: "",
                uApp: navigator.userAgent,
                h5Data: {},
                extraData: {},
                wechatData:{},
                activityId:null,//活动id
                activityType:null,//控制页面是否展示对应模块（zt：抽奖，mz:买一赠一）标识,取this.$route.params.activity_type值
                currentLotteryTpl: 'BlindBoxTpl',//抽奖模板,BlindBoxTpl:盲盒、TurntableTpl：转盘(带style参切换)
                allowClick:true,//控制按钮是否响应点击标识

                member: null,
                memberPoints: 0,//积分
                bind_wx: 0,//是否已绑定微信
                memberId: '',
            };
        },
        watch: {
            "$store.getters.MemberInfo": {
                deep: true,
                handler(val) {
                    if (this.isLogin) {
                        
                    }
                }
            }
        },
        computed: {
            ...mapGetters(["token","MemberInfo"]),
            isLogin(){
                return this.$store.getters.token
            }
        },
        created() {
            let params=this.$route.params
            // console.log(`params:${JSON.stringify(params)}`)
            this.activityType=params.activity_type
            this.activityId=params.activity_id

            if (this.activityType == 'zt') {
                let query = this.$route.query
                if (query['style'] == 2) {
                    this.currentLotteryTpl = 'TurntableTpl'
                }

               if (!this.isLogin && this.$browser.isWechat) {//未登录 && 微信中打开,自动登录
                    let params={
                        refurl: location.href
                    }
                    ajaxWxLogin(params).then((res)=>{
                        let {data}=res
                        let { wx_login_url }=data
                        if(wx_login_url){
                            location.href= wx_login_url
                        }
                    }).catch((err)=>{
                        console.log(err)
                    })
                }
            }
        },
        mounted() {
            this.getUser()

            this.getActivity()

            //监听滚动事件
            window.addEventListener('scroll', () => {
                let $scroll = $(document).scrollTop();
                //背景逐渐变暗
                let topPage = $(".module-hd").offset().top;
                let opacity = $scroll / topPage;
                if(opacity > 1){
                    opacity = 1;
                }
                $(".activity-background .page-mask").css("opacity", opacity);
            });
        },
        methods: {
            async getUser() {
                if (this.isLogin) {
                    let res = await this.$store.dispatch("home/getUserInfo");

                    this.member = this.MemberInfo
                    let { member_points, bind_wx, member_id } = this.member
                    this.memberPoints = member_points
                    this.bind_wx = bind_wx
                    this.memberId = member_id
                }
            },
            async getActivity(){
                let data = {
                    activity_id: this.activityId,
                }
                const res = await getActivity(data)
                if (res.msg == "Success") {
                    if(this.activityType=='mz'){//插入'买一赠一'模块
                        res.data.activity_column.splice(2,0,{
                            amc_type: 7,
                            amc_detail:{
                                column_title_img:require('../../../../assets/images/activity/mz/mz_title.png'),
                                column_back_img:require('../../../../assets/images/activity/mz/mz_bg.png'),
                                mz_arr:[
                                    {
                                    mz_link:'https://m.yiihuu.com/video/zuhe.php?id=227',
                                    mz_img:require('../../../../assets/images/activity/mz/mz_01.png')   
                                    },
                                    {
                                    mz_link:'https://m.yiihuu.com/video/zuhe.php?id=228',
                                    mz_img:require('../../../../assets/images/activity/mz/mz_02.png')   
                                    },
                                    {
                                    mz_link:'https://m.yiihuu.com/video/zuhe.php?id=229',
                                    mz_img:require('../../../../assets/images/activity/mz/mz_03.png')   
                                    },
                                    {
                                    mz_link:'https://m.yiihuu.com/video/zuhe.php?id=230',
                                    mz_img:require('../../../../assets/images/activity/mz/mz_04.png')   
                                    },
                                    {
                                    mz_link:'https://m.yiihuu.com/video/zuhe.php?id=231',
                                    mz_img:require('../../../../assets/images/activity/mz/mz_05.png')   
                                    },
                                    {
                                    mz_link:'https://m.yiihuu.com/video/zuhe.php?id=232',
                                    mz_img:require('../../../../assets/images/activity/mz/mz_06.png')   
                                    },
                                ]
                            }
                        });
                    }
                    // res.data.activity_column.splice(3,0,{amc_type: 6});
                    if (this.activityType == 'zt') {//插入'抽奖'模块
                        res.data.activity_column.splice(2, 0, { amc_type: 6 });
                    }
                    
                    //每个热门课程模块插入模块当前激活tab索引独立标识
                    let activityColumn = res.data.activity_column
                    activityColumn.forEach(item => {
                        if (item.amc_type == 4) {
                            item.hotActive = 0
                        }
                    });

                    let query = this.$route.query
                    if (query['barrage'] == 1) {//插入'flag留言墙'模块
                        res.data.activity_column.splice(3, 0, {
                            amc_type: 8,
                            amc_detail: {
                                column_title_img: require('@/assets/images/activity/barrage/barrage_title.png'),
                                column_back_img: require('@/assets/images/activity/barrage/mhd_item_08.png'),
                                pc_column_btn_img: require('@/assets/images/activity/barrage/send_button.png'),
                                pc_column_btn_hover: require('@/assets/images/activity/barrage/send_button_on.png'),
                            }
                        });
                    }
                    
                    this.initData = res.data;
                    this.isActivity = this.initData.is_activity;
                    let hdUrl = this.$CommonFun.getQueryString("preview");
                    this.preview = hdUrl ? hdUrl : 0;
                    if (this.preview) {//活动预览
                        this.isActivity = 1
                    }
                    this.noticeText = this.isActivity != 1 ? (this.isActivity == 2 ? "活动已经结束，敬请期待下次的活动哦" : "活动还未开始，敬请期待") : "";
                    if(this.isActivity == 1){
                        this.countTime = this.initData.end_time;
                        this.wechatData = {
                            title: this.initData.am_title + '_翼狐网', // 分享标题
                            desc: '学设计，上翼狐！超值活动福利来袭，别错过哦~', // 分享描述
                            link: window.location.href, // 分享链接
                            imgUrl: 'https://m.yiihuu.com/assets/activity/hd021/images/share.jpg', // 分享图标
                        }
                        this.$nextTick(() => {
                            this.showtime();
                            this.$initWxShareConfig(this.wechatData);
                        });
                    }else{
                        setTimeout(() => {
                            location.href = this.$commonVariable.yihu_href_url;
                        }, 10000);
                    }
                }
            },
            //定时器
            showtime(){
                document.getElementById("countdown").style.display = "block";
                let timerObj;
                let nowtime = new Date();
                let ymdArr= this.countTime.split('-');
                let endtime = new Date(ymdArr[0], ymdArr[1], ymdArr[2],23,59,59);
                let lefttime = parseInt((endtime.getTime() - nowtime.getTime()));
                let d = parseInt(lefttime / 1000 / (24 * 60 * 60));
                let h = parseInt(lefttime / 1000 / (60 * 60) % 24);
                let m = parseInt(lefttime / 1000 / 60 % 60);
                let s = parseInt(lefttime / 1000 % 60);
                let ms = parseInt(lefttime / 1000);
                if (lefttime > 0) {
                    d = parseInt(lefttime / 1000 / 60 / 60 / 24);
                    h = parseInt(lefttime / 1000 / 60 / 60 % 24);
                    m = parseInt(lefttime / 1000 / 60 % 60);
                    s = parseInt(lefttime / 1000 % 60);
                    ms = parseInt(lefttime % 1000);
                } else {
                    h = m = s = "00";
                    ms = '000';
                }
                d = this.PrefixInteger(d, 2);
                h = this.PrefixInteger(h, 2);
                m = this.PrefixInteger(m, 2);
                s = this.PrefixInteger(s, 2);
                ms = this.PrefixInteger(ms, 3);
                this.countData = {
                    time: h,
                    branch: m,
                    second: s,
                    millisecond: ms,
                };
                if (lefttime == 0) {
                    document.getElementById("countdown").style.display = "none";
                    clearTimeout(timerObj);
                    setTimeout(() => {
                        window.location.reload(true);
                    }, 1200);
                    return false;
                } else if (lefttime < 0) {
                    document.getElementById("countdown").style.display = "none";
                    clearTimeout(timerObj);
                }
                timerObj = setTimeout(this.showtime, 40);
            },
            PrefixInteger(num, length) {
                return (Array(length).join("0") + num).slice(-length);
            },

            hotAcitev(item, nav) {
                item.hotActive = nav;
            },

            //课程hover事件
            courseImageSrc(ev,num,hover,color){
                let this_=ev.target
                if(num==1){
                    let text=this_.querySelector('.bt_text')
                    text.style.cssText = 'color:'+ hover
                }else{
                    let cssTxt
                    if(hover){//鼠标移入
                       cssTxt='border: 2px solid '+ hover+';background-color:'+ hover 
                    }else{
                       cssTxt='border: 2px solid '+ color+';color:'+ color 
                    }
                    this_.style.cssText =cssTxt
                }
            },

            //vip专区
            showVip() {
                if(/isapp/i.test(this.uApp)){//当前h5页面在APP内打开
                    this.h5Data = {
                        jumpData: {
                            jump_to_type: 2,
                            level:2 //跳vip权益页
                        }
                    };
                    this.sendEventAction(this.h5Data);
                }else{
                    // alert('不是在app内打开')
                    // alert(navigator.userAgent)
                    location.href = this.$commonVariable.yihu_href_url +'/vip/';
                }
            },

            //大师课
            recomMend(){
                if (/isapp/i.test(this.uApp)) {
                    this.h5Data = {
                        jumpData: {
                            jump_to_type: 4
                        }
                    };
                    this.sendEventAction(this.h5Data);
                } else {
                    location.href = this.$commonVariable.yihu_href_url +'/bc/';
                }
            },

            //详情页
            courseTo(aid){
                if (/isapp/i.test(this.uApp)) {//当前h5页面在APP内打开
                    this.h5Data = {
                        browser: 1,
                        jumpData: {
                            jump_to_type: 1,
                            album_id: aid
                        }
                    };
                    this.sendEventAction(this.h5Data);
                } else {
                    // alert('不是在app内打开')
                    // alert(navigator.userAgent);
                    location.href = this.$commonVariable.yihu_href_url +'/a_' + aid + '.html';
                }
            },

            //h5页面通知APP，回传数据给APP
            sendEventAction(h5Data) {
                console.log(`h5Data:${JSON.stringify(h5Data)}`)
                // console.log(`extraData:${JSON.stringify(extraData)}`)

                // 跟app交互主要方法
                // h5CallbackData、extraData 空值传{}
                // 跳转能力调用app内首页openEntrance方法
                api.sendEvent({
                    name: 'h5CallbackEvent',
                    extra: {
                        h5CallbackData: h5Data,
                        extraData: this.extraData
                    }
                });
            },
            async getCouponFn(){
                if(!this.isLogin){
                   this.showLogin();
                   return
                }
                if(this.allowClick){
                    this.allowClick=false
                    let data = {
                        activity_id: this.activityId,
                        show_error_msg:false
                    }
                    
                    // getCoupons(data).then(res => {
                    //     if (res.code === 0) {
                    //         this.$layer.msg('领取成功，去购买教程吧')
                    //     }else{
                    //         this.$layer.msg(res.msg)
                    //     }
                    // }).catch(err => {
                    // console.log(err);
                    // }).finally(()=> {
                    //     this.allowClick=true
                    // });

                    let res=await getCoupons(data)
                    this.allowClick=true
                    if(res.code===0){
                        this.$layer.msg('领取成功，去购买教程吧')
                    }else{
                        this.$layer.msg(res.msg)
                    }
                }
            },
            copyLink() {
                let url = location.href
                let search = location.search
                if (search) {
                    let reg = /(TG=)(\d+)/ //匹配'TG=123'格式
                    if(reg.test(search)){//替换TG值
                        url=url.replace(/(TG=)(\d+)/, '$1' + this.memberId)
                    }else{
                        url = `${url}&TG=${this.memberId}`
                    }
                } else {
                    url = `${url}?TG=${this.memberId}`
                }
                this.$clipboard(url)
                this.$layer.msg('链接已复制，快去发给好友助力吧')
            },
            toPointsBox() {
                this.luckLayer()
            },
            showLogin() {
               this.$layer.msg('请先登录');
                setTimeout(() => {
                    window.location.href = process.env.VUE_APP_LOGIN_API + '/m_login.html?v=3&target_uri=' + location.href;
                }, 600);
            },
        }
    }
</script>

<style lang="scss" scoped>
    .activity-wrap{
        width: 100%;
        position: relative;
        margin: 0 auto;
        .activity-background{
            width: 100%;
            height: calc(100% - 100px);
            background-repeat: no-repeat;
            background-position: top center;
            background-size: cover;
            position: fixed;
            top: 100px;
            left: 50%;
            transform: translate(-50%,0);
            z-index: 8;
            .page-mask{
                width: 100%;
                height: 100%;
                opacity: 0;
                position: absolute;
                top: 0;
                left: 0;
            }
        }
        .activity-main{
            width: 100%;
            max-width: 750px;
            position: relative;
            padding: 100px 0 90px;
            box-sizing: border-box;
            z-index: 10;
            .module-banner{
                width: 100%;
                position: relative;
                overflow: hidden;
                .activity-banner{
                    width: 100%;
                    display: block;
                    position: relative;
                }
                .activity-countdown{
                    width: 100%;
                    height: 70px;
                    background-repeat: no-repeat;
                    background-position: top center;
                    background-size: cover;
                    text-align: center;
                    padding: 10px 0;
                    position: absolute;
                    bottom: 48px;
                    left: 50%;
                    transform: translate(-50%,0);
                    box-sizing: border-box;
                    ::v-deep span{
                        height: 50px;
                        line-height: 52px;
                        font-weight: bold;
                        display: inline-block;
                        vertical-align: top;
                        &:nth-child(odd){
                            font-size: 20px;
                            color: #ffffff;
                        }
                        &:nth-child(even){
                            width: 70px;
                            font-size: 24px;
                            color: #ffffff;
                            text-align: center;
                            background-repeat: no-repeat;
                            background-position: top center;
                            background-size: cover;
                            letter-spacing: 1px;
                            box-sizing: border-box;
                            margin: 0 12px;
                        }
                        &:nth-child(1){ letter-spacing: 1px; }
                        &:nth-child(2){ margin-left: 0px;}
                        &:last-child{ margin-right: 0px; }
                    }
                }
            }
            .module-box{
                width: 100%;
                .module-hd{
                    width: calc(100% - 30px);
                    position: relative;
                    margin: 0 auto;
                    z-index: 9;
                    .module-title{
                        width: 100%;
                        margin-bottom: 20px;
                        img{
                            width: 570px;
                            display: block;
                            margin: 0 auto;
                        }
                    }
                    .mhd-content{
                        width: 100%;
                        position: relative;
                        .item-image{
                            width: 100%;
                            display: block;
                        }
                        .mhd-page{
                            width: 100%;
                            position: absolute;
                            top: 0;
                            left: 0;
                        }
                    }
                    &:not(:last-child){ margin-bottom: 50px; }
                    &.moduleHd_01{
                        .mhd-content{
                            .mhd-page{
                                padding: 50px 38px 0px;
                                img{ display: block; }
                                .coupon-list{
                                    width: 100%;
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: flex-start;
                                    .coupon_an{
                                        width: 198px;
                                        display: block;
                                        &:only-child{
                                            width: 100%;
                                        }
                                    }
                                }
                                .coupon-buy{
                                    width: 100%;
                                    position: relative;
                                    margin-top: 40px;
                                    .coupon_robvip_an{
                                        width: 104px;
                                        height: 104px;
                                        background-repeat: no-repeat;
                                        background-position: top center;
                                        background-size: cover;
                                        position: absolute;
                                        top: 50%;
                                        right: 44px;
                                        margin-top: -52px;
                                        -webkit-animation: free_download 0.7s linear alternate infinite;
                                        animation: free_download 0.7s linear alternate infinite;
                                        transition: all ease 0.2s;
                                    }
                                    @-webkit-keyframes free_download{
                                        0% {transform: scale(0.9);}
                                        100% {transform: scale(1);}
                                    }
                                    @keyframes free_download{
                                        0% {transform: scale(0.9);}
                                        100% {transform: scale(1);}
                                    }
                                }
                                .coupon-href{
                                    width: 308px;
                                    display: block;
                                    position: relative;
                                    margin: 40px auto 0;
                                    img{
                                        width: 100%;
                                        display: block;
                                    }
                                }
                            }
                        }
                    }
                    &.moduleHd_02{
                        .mhd-content{
                            .mhd-page{
                                padding: 50px 35px 0px;
                                .mhdVip-item{
                                    width: 100%;
                                    .mhdVip-show{
                                        cursor: pointer;
                                        &:not(:nth-child(3)){
                                            width: calc((100% / 2) - 17px);
                                        }
                                        &:nth-child(1){
                                            float: left;
                                        }
                                        &:nth-child(2){
                                            float: right;
                                        }
                                        &:nth-child(3){
                                            width: 100%;
                                            margin-top: 30px;
                                            float: left;
                                        }
                                        img{
                                            display: block;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    &.moduleHd_03{
                        .mhd-content{
                            .mhd-page{
                                padding: 50px 35px 0px;
                                .mhdEnlarge-item{
                                    width: 100%;
                                    position: relative;
                                    .enlarge-img{
                                        width: 100%;
                                        display: block;
                                        &:not(:last-child){
                                            margin-bottom: 40px;
                                        }
                                        img{
                                            width: 100%;
                                            display: block;
                                        }
                                    }
                                }
                                .mhdEnlarge-list{
                                    width: 100%;
                                    .enlarge-img{
                                        width: calc((100% / 2) - 15px);
                                        margin-bottom: 30px;
                                        &:nth-child(odd){
                                            float: left;
                                        }
                                        &:nth-child(even){
                                            float: right;
                                        }
                                        img{
                                            width: 100%;
                                            display: block;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    &.moduleHd_04{
                        .mhd-content{
                            .mhd-page{
                                padding: 50px 20px 0px;
                                .mhdHot-course{
                                    width: 100%;
                                    padding: 0 15px;
                                    position: relative;
                                    box-sizing: border-box;
                                    li{
                                        width: calc((100% / 2) - 9px);
                                        background-color: #ffffff;
                                        border-radius: 10px;
                                        padding: 14px;
                                        margin-bottom: 18px;
                                        position: relative;
                                        &:nth-child(odd){
                                            float: left;
                                        }
                                        &:nth-child(even){
                                            float: right;
                                        }
                                        &:nth-child(9){
                                            display: none;
                                        }
                                        .course-tp{
                                            width: 100%;
                                            height: 204px;
                                            display: block;
                                            overflow: hidden;
                                            img{
                                                width: 100%;
                                                height: 100%;
                                                display: block;
                                            }
                                        }
                                        .course-text{
                                            width: 100%;
                                            margin-top: 10px;
                                            .bt_text{
                                                height: 44px;
                                                line-height: 22px;
                                                color: #333333;
                                                font-size: 18px;
                                                text-align: justify;
                                                font-weight: bold;
                                                display: -webkit-box;
                                                -webkit-box-orient: vertical;
                                                -webkit-line-clamp: 2;
                                                overflow: hidden;
                                            }
                                            .course-ex{
                                                margin: 9px 0 10px;
                                                color: #262626;
                                                font-size: 16px;
                                                .send-mark{
                                                    width: 22px;
                                                    height: 22px;
                                                    line-height: 22px;
                                                    margin-right: 7px;
                                                    color: #fff;
                                                    text-align: center;
                                                    background-color: #f33;
                                                }
                                                a:hover{
                                                    color: #f33;
                                                }
                                            }
                                            .course-w1{
                                                width: 100%;
                                                display: flex;
                                                justify-content: space-between;
                                                align-items: center;
                                                margin-top: 18px;
                                                .fl_text{
                                                    display: inline-block;
                                                    vertical-align: top;
                                                    p{
                                                        line-height: 20px;
                                                        font-size: 16px;
                                                        color: #666666;
                                                        display: flex;
                                                        justify-content: flex-start;
                                                        align-items: center;
                                                        &.original{
                                                            margin-bottom: 2px;
                                                            span{
                                                                color: #777;
                                                                text-decoration: line-through;
                                                            }
                                                        }
                                                        .course_price{
                                                            font-weight: 700;
                                                        }
                                                    }
                                                }
                                                .details{
                                                    width: 110px;
                                                    height: 38px;
                                                    line-height: 38px;
                                                    font-size: 16px;
                                                    font-weight: bold;
                                                    color: #ffffff;
                                                    text-align: center;
                                                    display: inline-block;
                                                    vertical-align: top;
                                                }
                                            }
                                            .course-ex-wrap + .course-w1{
                                                margin-top: 0;
                                            }
                                        }
                                        .course-tag-mark{
                                            position: absolute;
                                            left: 0;
                                            top: 0;
                                            border-radius: 10px 0 0 0;
                                        }
                                    }
                                }
                                .mhdHot-item{
                                    width: 100%;
                                    position: relative;
                                    .mhdHot-courseNav{
                                        width: 100%;
                                        display: flex;
                                        justify-content: space-evenly;
                                        align-items: center;
                                        margin-bottom: 30px;
                                        li{
                                            width: 210px;
                                            position: relative;
                                            cursor: pointer;
                                            float: left;
                                            &.on{
                                                .hoverIocn{
                                                    opacity: 1;
                                                }
                                            }
                                            img{
                                                width: 100%;
                                                display: block;
                                                transition: all ease 0.2s;
                                                &.hoverIocn{
                                                    position: absolute;
                                                    top: 0;
                                                    left: 0;
                                                    opacity: 0;
                                                }
                                            }
                                        }
                                    }
                                    .mhdHot-courseList{
                                        width: 100%;
                                        position: relative;
                                    }
                                }
                            }
                        }
                    }
                    &.moduleHd_05{
                        .mhdNotice-item{
                            width: 100%;
                            display: block;
                        }
                    }
                    // &.moduleHd_06{
                    //     width: 100%;
                    // }
                    &.moduleHd_07{
                        .mhd-content{
                            .mhd-page{
                                padding: 50px 35px 0px;
                                .mhd-columm-item{
                                    max-width: calc(50% - 9px);
                                    a{
                                        display: block;
                                        margin-bottom: 18px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .guide-bottom{
            width: 100%;
            height: 100px;
            background-repeat: no-repeat;
            background-position: top center;
            background-size: cover;
            position: fixed;
            top: 0;
            left: 0;
            z-index: 999;
        }
        .hd_notice{
            width: 100%;
            line-height: 30px;
            font-size: 24px;
            color: #333333;
            font-weight: bold;
            text-align: center;
            padding: 14px 0;
        }
        
    }
</style>
